var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import MuiTextField from '@material-ui/core/TextField';
import styled from 'styled-components';
import defaultTheme from '../palette';
import { DownCaretIcon } from '../Icon';
// apply styles from MuiSelect-icon and MuiSelect-iconOutlined which is used in MUI original dropdown icon implementation
var GrayDownCaretIcon = styled(DownCaretIcon)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n  top: calc(50% - 12px);\n  right: 4%;\n  position: absolute;\n  pointer-events: none;\n"], ["\n  color: ",
    ";\n  top: calc(50% - 12px);\n  right: 4%;\n  position: absolute;\n  pointer-events: none;\n"])), function (props) { var _a, _b; return ((_b = (_a = props === null || props === void 0 ? void 0 : props.theme) === null || _a === void 0 ? void 0 : _a.palette) === null || _b === void 0 ? void 0 : _b.grey[600]) || (defaultTheme === null || defaultTheme === void 0 ? void 0 : defaultTheme.grey[600]); });
/**
 * Kareo wrapped component of the Material-UI TextField. The prop API has been limited to props defined in TextFieldProps.
 *
 * Text fields let users enter and edit text.
 *
 * Material-UI TextField: [Docs](https://v4.mui.com/components/text-fields/), [API](https://v4.mui.com/api/text-field/)
 *
 * @storybook: [TextField](http://design.kareoprod.ent/?path=/story/design-system_components-inputs-textfield--text-field-example)
 */
var TextField = React.forwardRef(function (_a, ref) {
    var _b = _a.rows, rows = _b === void 0 ? 5 : _b, _c = _a.select, select = _c === void 0 ? false : _c, SelectProps = _a.SelectProps, props = __rest(_a, ["rows", "select", "SelectProps"]);
    return (React.createElement(MuiTextField, __assign({ ref: ref, variant: "outlined", select: select, SelectProps: __assign(__assign({}, SelectProps), { IconComponent: select
                ? function () { return React.createElement(GrayDownCaretIcon, { fontSize: "xsmall" }); }
                : undefined }), 
        // Use a value of 'grow' to restore original height growth behavior
        rows: rows === 'grow' ? undefined : rows }, props)));
});
TextField.defaultProps = {};
TextField.displayName = 'TextFieldKareo';
export default TextField;
var templateObject_1;
